import headquarterPointedOut from './headquarterPointedOut';

export default headquarterPointedOut;
